export enum PortalSource {
  STUDENT_RESOURCE = 'studentresource',
  UMR = 'umr',
  GRI = 'gri',
  UHOPS = 'uhops',
}

export enum PortalIdentifier {
  STANDARD = 'standard',
  GEHA = 'geha',
  CUSTOM = 'custom',
  NV = 'NV',
}
